export enum SiteRFPStatus {
  EngagementLetter = 'EngagementLetter',
  PreRFP = 'PreRFP',
  RFP = 'RFP',
  Contracts = 'Contracts',
  PreNTP = 'PreNTP',
  Construction = 'Construction',
  Complete = 'Complete',
  ConsultingComplete = 'ConsultingComplete',
}
